import { Temporal } from "@js-temporal/polyfill";

// Gets the current time zone offset in UTC for a given IANA time zone. (e.g., "America/New_York" => "-05:00")
export const getTimeZoneOffsetInUTC = (ianaTimeZone: string): string | null => {
  try {
    const zdt = Temporal.Now.zonedDateTimeISO(ianaTimeZone);
    return zdt.offset;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error("Invalid time zone:", e);
    return null;
  }
};
